export class Settings {
    public static get DateFormatForAPIMoment(): string {
        return `YYYY-MM-DD'T'HH:mm:ss`;
    }

    public static get DateTimeFormatMoment(): string {
        return `DD.MM.YYYY HH:mm:ss`;
    }

    public static get DateFormatMoment(): string {
        return `DD.MM.YYYY`;
    }

    public static get DateOnlyFormatForAPIMoment(): string {
        return `YYYY-MM-DDT00:00:00`;
    }

    public static get OffSetDefault(): string {
        return "Europe/Moscow";
    }

    public static get RootUrl(): string {
        return `https://lk.cyfral-group.ru`;
    }

    public static get IdentityServer(): string {
        return `https://authlk.cyfral-group.ru`;
    }

    public static get ApplicationAPIBaseUrl(): string {
        return `https://api-lk.cyfral-group.ru/api`;
    }


    public static get CyfralServiceSite(): string {
        return `https://cyfral-group.ru/`;
    }

    public static get PayCyfralServiceSite(): string {
        return `https://pay.cyfral-group.ru/`;
    }


}